import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { UpdateService } from '../../service/update.service';
import * as updateActions from './update.actions';

@Injectable()
export class UpdateActivityEffects {
    constructor(private actions$: Actions, private updateService: UpdateService) {}

    cancelActivity$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.cancelActivity),
            exhaustMap(action =>
                this.updateService.cancelActivity(action.cancelActivity).pipe(
                    map(() => updateActions.cancelActivitySuccess())
                )
            )
        )
    );

    validateActivity$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.validateActivity),
            exhaustMap(action =>
                this.updateService.validateActivity(action.validateActivity).pipe(
                    map(() => updateActions.validateActivitySuccess()),
                    catchError(() => EMPTY)
                )
            )
        )
    );

    removeTask$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.removeTask),
            exhaustMap(action =>
                this.updateService.removeTask(action.idTask).pipe(
                    map(() => updateActions.removeTaskSuccess())
                )
            )
        )
    );

    removeService$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.removeService),
            exhaustMap(action =>
                this.updateService.removeService(action.idService).pipe(
                    map(() => updateActions.removeServiceSuccess())
                )
            )
        )
    );

    validateTask$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.validateTask),
            exhaustMap(action =>
                this.updateService.validateTask(action.idTask).pipe(
                    map(() => updateActions.validateTaskSuccess())
                )
            )
        )
    );

    validateService$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.validateService),
            exhaustMap(action =>
                this.updateService.validateService(action.idService).pipe(
                    map(() => updateActions.validateServiceSuccess())
                )
            )
        )
    );
}
